<template>
  <div>
    <messagePopup
      :dialog-title="titleText"
      :append-to-body="true"
      :dialog-type="''"
      :popup-top="'10vh'"
      :show-close="false"
      :center-dialog-visible="dialogVisible"
      :popup-width="'800px'"
      :show-btn="false"
      :center="true"
      @updateVisible="dialogVisible = false"
      @resetPopupData="dialogVisible = false"
    >
      <div class="box">
        <div class="content_box">
          <div class="box_text" v-html="complianCecommitmentLetter"></div>
          <div class="text_info">
            <p>公司：{{ complianceData.companyName }}</p>
            <p>联系人姓名：{{ complianceData.linkName }}</p>
            <p>签署日期：{{ getFormatDate(new Date().getTime()) }}</p>
          </div>
        </div>
        <div
          v-if="complianceData.isAdmin === 1"
          class="submit_btn"
          @click="handleSubmit()"
        >
          签署
        </div>
        <div v-else class="tipsText">
          请联系公司管理员登录易派客平台完成签署
        </div>
      </div>
    </messagePopup>
  </div>
</template>

<script>
import { complianCecommitmentLetter } from '@/assets/js/cerword.js';
import { debounce } from '@/modules/projectA/utils/throttle.js';
import { dateformate } from '@/assets/js/companyFilter';
import messagePopup from './e-messagePopup.vue';
import api from '../../modules/projectA/api/nesting';

export default {
  components: {
    messagePopup,
  },
  props: {
    complianceData: {
      type: Object,
      default: () => {
        return {
          companyName: '', // 公司名称
          linkName: '', // 联系人名称
          companyConformance: '0', // 合规承诺函，是否弹窗 1 弹窗， 0 不弹窗
        };
      },
    },
  },
  data() {
    return {
      complianCecommitmentLetter,
      dialogVisible: false,
      titleText: '合规承诺函',
    };
  },
  watch: {
    complianceData(newVal) {
      console.log(newVal);
      if (newVal) {
        if (newVal.companyConformance === 1) {
          this.dialogVisible = true;
        }
      }
    },
  },
  mounted() {},
  methods: {
    // 日期格式化
    getFormatDate(dates) {
      return dateformate(dates, 'yyyy年MM月dd日');
    },
    handleSubmit() {
      debounce(() => {
        this.saveAgreementConformance();
      }, 1000);
    },
    saveAgreementConformance() {
      api.saveAgreementConformance().then((res) => {
        if (res.success) {
          this.dialogVisible = false;
          this.$message.success('提交成功');
        } else {
          this.$message.error('提交失败');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  padding: 0 30px 20px;
  .content_box {
    width: 100%;
    min-height: 300px;
    max-height: 600px;
    overflow-y: auto;
    .text_info {
      // text-align: right;
      padding: 20px 0;
      // min-width: 180px;
      float: right;
    }
    .text_info:after {
      clear: both;
    }
  }
  .submit_btn {
    margin: 20px auto 0;
    cursor: pointer;
    width: 80px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #2587ff;
    color: #fff;
    &:hover,
    :active {
      background-color: #126edf;
    }
  }
  .tipsText {
    text-align: center;
    color: #126edf;
  }
}
::v-deep.el-input__inner {
  width: 300px;
  border-radius: 0;
  color: #333;
}
::v-deep.el-form-item__label {
  font-size: 14px;
  color: #333;
}
</style>
